import { Injectable } from '@angular/core';
import { AbstractDispatcherAction, AbstractDispatcherService } from 'buzzyears.ui';

export enum WorkflowGraphDispatcherActionType {
  SelectVertex = 'select-vertex',
  MultiSelectVertex = 'multi-select-vertex',
  VertexMoving = 'vertex-moving',
  VertexMoved = 'vertex-moved',
  VertexUpdated = 'vertex-updated',
  VertexSelected = 'vertex-selected',

  ConnectionDrawInitiated = 'connection-draw-initiated',
  ConnectionDrawTerminated = 'connection-draw-terminated',
  ConnectionDrawReceiverActivated = 'connection-draw-receiver-activated',
  ConnectionDrawReceiverDeactivated = 'connection-draw-receiver-deactivated',
  ConnectionCreateRequest = 'connection-create-request',

  WorkflowTested = 'workflow-tested'
}

export interface WorkflowGraphDispatcherAction extends AbstractDispatcherAction {
  type: WorkflowGraphDispatcherActionType;
  data?: any;
}

@Injectable()
export class WorkflowGraphDispatcherService extends AbstractDispatcherService<WorkflowGraphDispatcherAction> {
  dispatchAction(type: WorkflowGraphDispatcherActionType, originator: any = null, data: any = null) {

    if (!type) {
      // Do nothing...
      return;
    }

    this.dispatch({
      type: type,
      originator: originator,
      data: data
    });
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/workflow-graph-dispatcher.service.ts